import React from 'react';
import DashboardComponent from '../../components/Dashboard/Dashboard';

const DashboardPage: React.FC = () => {
  return <DashboardComponent />;
};

export default DashboardPage;